import { Box, Stack, Typography, useTheme } from "@mui/material";
import type { FormSubmissionDetailDto } from "src/http";
import { FormSubmissionAnswer } from "./FormSubmissionAnswer";

interface Props {
  formSubmission: FormSubmissionDetailDto;
}

const FormSubmission = (props: Props) => {
  const theme = useTheme();

  return (
    <Stack spacing={2}>
      {[...props.formSubmission.questionGroups]
        .sort((a, b) => a.sortOrder.localeCompare(b.sortOrder))
        .map((questionGroup, i) => (
          <Stack key={i} spacing={1}>
            <Typography variant="h6" sx={{ borderBottom: `1px solid ${theme.palette.line.main}` }}>
              {questionGroup.name}
            </Typography>
            {...questionGroup.questions
              .filter((question) => question.typeConfig.type !== "TextBlock")
              .sort((a, b) => a.sortOrder.localeCompare(b.sortOrder))
              .map((question, j) => (
                <Box key={j}>
                  <Typography variant="body2">{question.name}</Typography>
                  <FormSubmissionAnswer questionTypeConfig={question.typeConfig} answer={question.answer} />
                </Box>
              ))}
          </Stack>
        ))}
    </Stack>
  );
};

export { FormSubmission };
